import { DataTable } from "../../../components/DataTable.tsx";
import { Button } from "../../../components/ui/button.tsx";
import {
  FaCheckCircle,
  FaDownload,
  FaExclamationCircle,
  FaExclamationTriangle,
  FaEye,
  FaPlus,
} from "react-icons/fa";
import Modal from "../../../components/Modal.tsx";
import { TextArea } from "../../../components/ui/TextArea";
import { Label } from "../../../components/ui/label.tsx";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  userService,
  userDataMap,
  invitationService,
  groupService,
  communityService,
  ServiceOnMount,
  dashboardService,
} from "../../../services";
import { Skeleton } from "../../../components/ui/skeleton";
import Papa from "papaparse";
import ShortenedText from "../../../components/ShortenedText.js";
import TableCard from "../../../components/TableCard";
import { GoLog, GoPeople } from "react-icons/go";
import LoadingImage from "../../../components/LoadingImage.js";
import { createItemStore } from "../../../stores/createItemStore";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import useUserStore2 from "../../../stores/userStore2.js";
import StatusBadge from "../../../components/table/StatusBadge"

const columns = [
  // {
  //   accessorKey: "userId",
  //   header: "User ID",
  //   cell: ({ row }) => (
  //     <span>
  //       <ShortenedText text={row.getValue("userId")} />
  //     </span>
  //   ),
  // },
  {
    accessorKey: "userName",
    header: "User Name",
    cell: ({ row }) => <span>{row.getValue("userName")}</span>,
  },
  {
    accessorKey: "role",
    header: "Designation",
    cell: ({ row }) => <span>{row.getValue("role")}</span>,
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => {
      const status = row.getValue("status");
      return (
        <StatusBadge
          status={status === "Deactivated" && !row.original.verified
            ? "Invitation sent"
            : status}
        />
      );
    },
  },
  {
    accessorKey: "lastLogin",
    header: "Last Login",
    cell: ({ row }) => (
      <span>
        {
          row.getValue("lastLogin")
            ? dayjs(row.getValue("lastLogin")).fromNow()
            : "never"
          // new Date(row.getValue("lastLogin")).toLocaleString()
        }
      </span>
    ),
  },
];

// ========================================================
// Step 1: Zustand store instantiation
// ========================================================
const storeName = "users";
const useItems = createItemStore(
  storeName,
  (user) => user.userId,
  userService.getUsers,
  userDataMap
);
// ========================================================

export default function UserManagementPage() {
  const navigate = useNavigate();
  const [showSuspendModal, setShowSuspendModal] = useState(false);
  const [comment, setComment] = useState("");
  const [showImportModal, setShowImportModal] = useState(false);
  const [file, setFile] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isApproveOpen, setIsApproveOpen] = useState(false);
  const [loading, setLoading] = useState(false); // Loading state
  const [row, setRow] = useState(null);
  const [reload, setReload] = useState(false);
  const [pendingRequests, setPendingRequests] = useState({
    total: 0,
    oldTotal: 0,
  });
  const { user } = useUserStore2();

  console.log("user.id: ", user?.id);

  const [isPendingRequestsLoading, setIsPendingRequestsLoading] =
    useState(true);

  // Update the pending requests useEffect
  useEffect(() => {
    const fetchPendingRequests = async () => {
      if (!user?.id) {
        setIsPendingRequestsLoading(true);
        return;
      }

      try {
        setIsPendingRequestsLoading(true);
        const response = await dashboardService.countTotalPendingRequests(
          user.id
        );
        setPendingRequests({
          total: response.total_pending_requests,
          oldTotal: response.total_pending_requests_old,
        });
      } catch (error) {
        console.error("Error fetching pending requests:", error);
        // Optionally set some error state here
      } finally {
        setIsPendingRequestsLoading(false);
      }
    };

    fetchPendingRequests();
  }, [reload, user?.id]);

  const groupMap = (item) => ({
    communityId: item.community._id,
    communityName: item.community.name,
    groupId: item._id,
    groupName: item.name,
    status: item.status,
  });

  const getGroups = ServiceOnMount(() => groupService.getGroups(), groupMap, [
    reload,
  ]);

  const communityMap = (item) => ({
    communityId: item._id,
    communityName: item.name,
    status: item.status,
  });

  const getCommunities = ServiceOnMount(
    () => communityService.getCommunity(),
    communityMap,
    [reload]
  );

  const handleFileImport = async () => {
    if (!file) {
      toast.error("Please select a file to import.", { autoClose: 2000 });
      return;
    }

    setLoading(true);

    try {
      // Create mappings for name to ID
      const communityNameToId = {};
      getCommunities.data?.forEach((community) => {
        communityNameToId[community.communityName.toLowerCase()] =
          community.communityId;
      });

      const groupNameToId = {};
      getGroups.data?.forEach((group) => {
        groupNameToId[group.groupName.toLowerCase()] = group.groupId;
      });

      const reader = new FileReader();

      reader.onload = async ({ target }) => {
        const csv = target.result;
        Papa.parse(csv, {
          header: true,
          skipEmptyLines: true,
          complete: async (result) => {
            try {
              const errors = [];
              const validRows = [];

              result.data.forEach((row, index) => {
                const rowNumber = index + 2; // +2 because CSV rows start at 1 and header is row 1
                let hasErrors = false;

                // Validate required fields
                if (!row.Email?.trim()) {
                  errors.push(
                    `Row ${rowNumber}: Missing required field - Email`
                  );
                  hasErrors = true;
                }
                if (!row.Name?.trim()) {
                  errors.push(
                    `Row ${rowNumber}: Missing required field - Name`
                  );
                  hasErrors = true;
                }
                if (!row.Role?.trim()) {
                  errors.push(
                    `Row ${rowNumber}: Missing required field - Role`
                  );
                  hasErrors = true;
                }
                if (!row.Community?.trim()) {
                  errors.push(
                    `Row ${rowNumber}: Missing required field - Community`
                  );
                  hasErrors = true;
                }

                if (hasErrors) return;

                // Process Community (required)
                const communityKey = row.Community.trim().toLowerCase();
                const communityId = communityNameToId[communityKey];

                if (!communityId) {
                  errors.push(
                    `Row ${rowNumber}: Community not found - "${row.Community}"`
                  );
                  return;
                }

                // Process Group (optional)
                let groupId = null;
                if (row.Group?.trim()) {
                  const groupKey = row.Group.trim().toLowerCase();
                  groupId = groupNameToId[groupKey];

                  if (!groupId) {
                    errors.push(
                      `Row ${rowNumber}: Group not found - "${row.Group}"`
                    );
                    return;
                  }
                }

                validRows.push({
                  Email: row.Email.trim(),
                  Name: row.Name.trim(),
                  Role: row.Role.trim(),
                  CommunityId: communityId,
                  GroupId: groupId || null,
                });
              });

              if (errors.length > 0) {
                toast.error(
                  <div>
                    <p>CSV validation errors:</p>
                    <ul className="list-disc pl-5 mt-1">
                      {errors.slice(0, 5).map((error, i) => (
                        <li key={i}>{error}</li>
                      ))}
                      {errors.length > 5 && (
                        <li>...and {errors.length - 5} more errors</li>
                      )}
                    </ul>
                  </div>,
                  { autoClose: false }
                );
                return;
              }

              if (validRows.length === 0) {
                toast.error("No valid rows found in CSV", { autoClose: 2000 });
                return;
              }

              const requestBody = {
                invitationList: validRows,
              };

              const response = await invitationService.bulkInvite(requestBody);
              fetchItems();
              toast.success(
                `🎉 Successfully imported ${validRows.length} users!`,
                {
                  autoClose: 2000,
                }
              );
              setShowImportModal(false);
              console.log("Bulk invite response:", response);
            } catch (error) {
              console.error("Error processing invitations:", error);
              toast.error(`❌ Error sending invitations: ${error.message}`, {
                autoClose: 3000,
              });
            } finally {
              setLoading(false);
            }
          },
          error: (error) => {
            console.error("CSV parsing error:", error);
            toast.error("❌ Error parsing CSV file", {
              autoClose: 2000,
            });
            setLoading(false);
          },
        });
      };

      reader.readAsText(file);
    } catch (error) {
      console.error("Error in import process:", error);
      toast.error("❌ Error during import process", {
        autoClose: 2000,
      });
      setLoading(false);
    }
  };

  const handleConfirmApprove = async () => {
    try {
      setLoading(true); // Start loading

      const userId = row.userId; // The ID of the user to be approved

      // Call the reusable enable function
      await userService.enableUser(userId);
      console.log("User activated (enabled) successfully!");
      fetchItems();

      setIsApproveOpen(false); // Close the modal
      setReload((prev) => !prev); // Refresh the data
      toast.success("🎉 User activated successfully!", {
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Error approving user:", error);
      toast.error("❌ Failed to activate user. Please try again later.", {
        autoClose: 2000,
      });
    } finally {
      setLoading(false); // End loading
    }
  };

  const handleConfirmSuspend = async () => {
    try {
      setLoading(true);
      const userId = row.userId; // The ID of the user to be suspended

      // Call the suspend function with comment
      await userService.suspendUser(userId, comment);
      console.log("User suspended successfully!");
      fetchItems();

      setShowSuspendModal(false); // Close the modal
      setReload((prev) => !prev); // Refresh the table
      toast.success("🎉 User has been Suspended!", {
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Error suspending user:", error);
      toast.error("❌ Failed to suspend user. Please try again later.", {
        autoClose: 2000,
      });
    } finally {
      setLoading(false);
      setComment("");
    }
  };

  const handleConfirmDeactivate = async () => {
    try {
      setLoading(true);
      const userId = row.userId; // The ID of the user to be suspended

      // Call the reusable disable function
      await userService.disableUser(userId);
      console.log("User deactivated successfully!");
      fetchItems();

      setIsOpen(false); // Close the modal
      setReload((prev) => !prev); // Refresh the table if needed
      toast.success("🎉 User has been deactivated successfully!", {
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Error deactivating user:", error);
      toast.error("❌Failed to deactivate user. Please try again later.", {
        autoClose: 2000,
      });
    } finally {
      setLoading(false); // End loading
    }
  };

  const actions = (row) => {
    const status = row.status;
    const baseActions = [
      {
        label: "View/Edit Details",
        icon: <FaEye />,
        onClick: () => navigate(`/users/view/${row.userId}`),
        variant: "dropPlain",
      },
      {
        label: "Activate User",
        icon: <FaExclamationTriangle />,
        onClick: () => {
          setRow(row);
          setIsApproveOpen(true);
        },
        variant: "dropGreen",
        hidden: status === "Active",
      },
      {
        label: "Suspend User",
        icon: <FaExclamationCircle />,
        onClick: () => {
          setRow(row);
          setShowSuspendModal(true);
        },
        variant: "dropRed",
        hidden: status === "Suspended" || status === "Deactivated",
      },
      {
        label: "Deactivate User",
        icon: <FaExclamationTriangle />,
        onClick: () => {
          setRow(row);
          setIsOpen(true);
        },
        variant: "dropRed",
        hidden: status === "Deactivated",
      },
    ];
    // Filter out hidden actions
    return baseActions.filter((action) => !action.hidden);
  };

  // ========================================================
  // Step 2: Zustand store and page hydration
  // ========================================================
  const { isLoading, fetchItems, getSortedFiltered } = useItems(
    (state) => state
  );
  const data = getSortedFiltered();
  const showLoading = data.length === 0 && isLoading;
  // console.log(`${storeName}:`, data);
  useEffect(() => {
    fetchItems();
  }, [reload]);
  // ========================================================

  console.log("data: ", data);

  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      <div className="flex-1 flex flex-col">
        <div className="flex-1 p-4 sm:p-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
            {/* Total Users - With Skeleton */}
            {showLoading ? (
              // {getUsers.loading ? (
              <Skeleton className="w-full h-32 rounded-xl" />
            ) : (
              <TableCard
                heading="Total Users"
                number={data.length}
                // number={getUsers.data.length}
                trend={{ percentage: "20%", isUp: true }}
                bgColor="from-teal-50 to-teal-300"
                icon={GoPeople}
                iconColor="text-teal-300"
                borderColor="border-l-teal-300"
              />
            )}

            {/* Pending Requests Card */}
            {isPendingRequestsLoading || showLoading ? (
              <Skeleton className="w-full h-32 rounded-xl" />
            ) : (
              <TableCard
                heading="Pending Requests"
                number={pendingRequests.total}
                trend={{
                  percentage: `${Math.abs(
                    ((pendingRequests.total - pendingRequests.oldTotal) /
                      (pendingRequests.oldTotal || 1)) *
                      100
                  ).toFixed(0)}%`,
                  isUp: pendingRequests.total > pendingRequests.oldTotal,
                }}
                bgColor="from-orange-50 to-orange-300"
                icon={GoLog}
                iconColor="text-yellow-400"
                buttonText="View More"
                buttonLink="/pending-requests"
                borderColor="border-l-yellow-400"
              />
            )}
          </div>
          <div className="bg-white shadow rounded-lg p-4 md:max-w-[calc(100vw-375px)] sm:p-6 text-sm md:mt-0">
            <div className="flex flex-col sm:flex-row justify-between items-center mb-4">
              <div className="text-base sm:text-lg font-semibold text-[#111827] mb-4 sm:mb-0">
                User List
              </div>
              <div className="flex space-x-4">
                <Button
                  onClick={() => {
                    console.log("Opening Import Modal...");
                    setShowImportModal(true);
                  }}
                  className="p-2 bg-[#F9FAFB] border-[#E5EEB] rounded border-[1px] text-sm sm:text-base text-[#6B7280] hover:bg-[#F0FDFA] hover:text-[#14B8A6] flex items-center"
                >
                  <FaDownload className="mr-2 h-4 w-4" /> Import
                </Button>

                <Button
                  onClick={() => navigate("/users/add")}
                  className="flex items-center px-4 py-2 bg-[#14B8A6] text-sm sm:text-base text-white rounded hover:bg-[#2DD4BF]"
                >
                  <FaPlus className="mr-2" /> Invite User
                </Button>
              </div>
            </div>
            <hr />
            {showLoading ? (
              // {getUsers.loading ? (
              <LoadingImage />
            ) : data.length > 0 ? (
              // ) : getUsers?.data.length > 0 ? (
              <DataTable
                columns={columns}
                data={data}
                // data={getUsers.data}
                actions={actions}
              />
            ) : (
              <div className="text-center text-gray-500 py-6">
                No requests found.
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Import Modal */}
      <Modal
        isOpen={showImportModal}
        onClose={() => setShowImportModal(false)}
        title="Import Users"
        description="Upload a CSV file with the exact column order:"
        icon={<FaDownload />}
        iconColor="green"
        actions={
          <div className="flex justify-between w-full">
            <Button
              variant={"secondary"}
              onClick={() => setShowImportModal(false)}
            >
              Cancel
            </Button>
            <Button onClick={handleFileImport} disabled={loading}>
              {loading ? "Importing..." : "Import"}
            </Button>
          </div>
        }
      >
        <Label>Upload File:</Label>
        <input
          type="file"
          accept=".csv"
          className="w-full border border-gray-300 p-2 rounded-lg"
          onChange={(e) => setFile(e.target.files[0])}
        />

        <div className="mt-4 text-sm text-gray-600">
          <p className="mt-4 font-medium">Field Requirements:</p>
          <p>
            CSV should include columns: Email, Name, Role, Community,
            Group(optional)
          </p>

          <p className="mt-4 font-medium">Available Communities:</p>
          <div className="text-xs bg-gray-100 p-2 rounded max-h-20 overflow-y-auto">
            {getCommunities.data?.map((c) => c.communityName).join(", ")}
          </div>

          <p className="mt-2 font-medium">Available Groups:</p>
          <div className="text-xs bg-gray-100 p-2 rounded max-h-20 overflow-y-auto">
            {getGroups.data
              ?.map((g) => `${g.groupName} (${g.communityName})`)
              .join(", ")}
          </div>
        </div>
      </Modal>

      {/* Activate user */}
      <Modal
        isOpen={isApproveOpen}
        onClose={() => setIsApproveOpen(false)}
        title="Activate User"
        description="Are you sure you want to Activate this account?"
        icon={<FaCheckCircle className="text-green-500" />}
        iconColor="green"
        actions={
          <div className="flex justify-between w-full">
            <Button
              variant={"secondary"}
              onClick={() => setIsApproveOpen(false)}
            >
              Cancel
            </Button>
            <Button onClick={handleConfirmApprove} disabled={loading}>
              {loading ? "Activating..." : "Activate User"}
            </Button>
          </div>
        }
      ></Modal>

      {/* Suspend user */}
      <Modal
        isOpen={showSuspendModal}
        onClose={() => setShowSuspendModal(false)}
        title="Suspend User"
        description="Are you sure you want to suspend this profile? Please provide a reason below."
        icon={<FaExclamationTriangle />}
        iconColor="red"
        actions={
          <div className="flex justify-between w-full">
            <Button
              variant={"secondary"}
              onClick={() => setShowSuspendModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant={"destructive"}
              onClick={handleConfirmSuspend}
              disabled={loading || comment.trim() === ""}
            >
              {loading ? "Suspending..." : "Suspend User"}
            </Button>
          </div>
        }
      >
        {/* Textarea for the suspension comment */}
        <div className="mt-4">
          <Label className="text-left block">
            Suspension Reason <span className="text-xs">(Required)</span>
          </Label>
          <TextArea
            // className="w-full border-gray-300 rounded-md shadow-sm focus:border-teal-500 focus:ring-teal-500 text-sm"
            rows={4}
            placeholder="Enter reason for suspension..."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </div>
      </Modal>

      {/* Deactivate user */}
      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title="Deactivate User"
        description="Are you sure you want to deactivate this profile? Please provide a reason below."
        icon={<FaExclamationTriangle className="text-red-500" />}
        iconColor="red"
        actions={
          <div className="flex justify-between w-full">
            <Button variant={"secondary"} onClick={() => setIsOpen(false)}>
              Cancel
            </Button>
            <Button
              variant={"destructive"}
              onClick={handleConfirmDeactivate}
              disabled={loading}
            >
              {loading ? "Deactivating..." : "Deactivate User"}
            </Button>
          </div>
        }
      ></Modal>
    </div>
  );
}
